module.exports = __webpack_public_path__ + "static/media/SubLogo.51f72a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/homepage_new/SubLogo.png
// module id = 2704
// module chunks = 0